// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { aiControllerCoachThreadById, aiControllerCoachThreads, aiControllerCreateCoachThread, aiControllerDeleteCoachThread, aiControllerReportThreadVoiceTurns, aiControllerTranscribe, aiControllerUpdateCoachThread, analyticsControllerDimensions, analyticsControllerOverview, analyticsControllerTrainingsPerDay, auswertungControllerBearbeitungsstatus, auswertungControllerExport, auswertungControllerPruefung, authControllerAbility, authControllerChangePassword, authControllerCompleteTour, authControllerConsent, authControllerLogout, authControllerMagicLink, authControllerMe, authControllerPassword, authControllerUpdateProfile, authControllerVerify, bereichFreigabeControllerEigene, bereichFreigabeControllerList, bereichFreigabeControllerSet, contentControllerCoachStyles, contentControllerPersonas, contentControllerRemoveCoachStyle, contentControllerRemovePersona, contentControllerUpsertCoachStyle, contentControllerUpsertPersona, einheitFreigabeControllerEigene, einheitFreigabeControllerList, einheitFreigabeControllerSet, healthControllerCheck, healthControllerPing, iddControllerAbbrechen, iddControllerGet, iddControllerKapitelAendern, iddControllerNachweis, iddControllerNachweisListe, iddControllerPruefungAbgeben, iddControllerPruefungStarten, iddControllerRunPruefen, iddControllerRunStand, iddControllerStart, iddControllerUebersicht, learningEssenceControllerGet, learningEssenceControllerRemove, learningEssenceControllerSkip, learningEssenceControllerStart, type Options, personalPersonasControllerArchive, personalPersonasControllerCreate, personalPersonasControllerUpdate, processRunControllerAdvance, processRunControllerAvTool, processRunControllerCreate, processRunControllerDebrief, processRunControllerGet, processRunControllerList, processRunControllerLoesung, processRunControllerNachbereitung, processRunControllerPreparation, processRunControllerReportVoiceTurns, pruefungControllerAntworten, pruefungControllerAuswertungen, pruefungControllerLernfelder, pruefungControllerLernstandAbrufen, pruefungControllerSetzeTermin, pruefungControllerVerlaengereZiel, pruefungControllerZuruecksetzen, reflectionControllerAdvance, reflectionControllerGet, reflectionControllerRemove, sessionsControllerAppendMessages, sessionsControllerComplete, sessionsControllerCreate, sessionsControllerGenerateFeedback, sessionsControllerGet, sessionsControllerHeartbeat, sessionsControllerList, sessionsControllerRateFeedback, sessionsControllerRemove, sessionsControllerReportVoiceTurns, teamFreigabeControllerGet, teamFreigabeControllerSetBereich, teamFreigabeControllerSetEinheit, teamsControllerCreate, teamsControllerList, teamsControllerRemove, teamsControllerSetMembers, teamsControllerUpdate, tenantsControllerAuditLog, tenantsControllerAuditLogPage, tenantsControllerCreate, tenantsControllerGet, tenantsControllerList, tenantsControllerSetBausteine, tenantsControllerSetEmailDomains, tenantsControllerSubprozessoren, tenantsControllerUpdate, tenantsControllerViewAs, usersControllerEntsperren, usersControllerIssueOneTimePassword, usersControllerList, usersControllerRemove, usersControllerSperren, usersControllerUpsert } from '../sdk.gen';
import type { AiControllerCoachThreadByIdData, AiControllerCoachThreadByIdResponse, AiControllerCoachThreadsData, AiControllerCoachThreadsResponse, AiControllerCreateCoachThreadData, AiControllerCreateCoachThreadResponse, AiControllerDeleteCoachThreadData, AiControllerDeleteCoachThreadResponse, AiControllerReportThreadVoiceTurnsData, AiControllerReportThreadVoiceTurnsResponse, AiControllerTranscribeData, AiControllerTranscribeResponse, AiControllerUpdateCoachThreadData, AiControllerUpdateCoachThreadResponse, AnalyticsControllerDimensionsData, AnalyticsControllerDimensionsResponse, AnalyticsControllerOverviewData, AnalyticsControllerOverviewResponse, AnalyticsControllerTrainingsPerDayData, AnalyticsControllerTrainingsPerDayResponse, AuswertungControllerBearbeitungsstatusData, AuswertungControllerBearbeitungsstatusResponse, AuswertungControllerExportData, AuswertungControllerPruefungData, AuswertungControllerPruefungResponse, AuthControllerAbilityData, AuthControllerAbilityResponse, AuthControllerChangePasswordData, AuthControllerChangePasswordResponse, AuthControllerCompleteTourData, AuthControllerCompleteTourResponse, AuthControllerConsentData, AuthControllerConsentResponse, AuthControllerLogoutData, AuthControllerLogoutResponse, AuthControllerMagicLinkData, AuthControllerMagicLinkResponse, AuthControllerMeData, AuthControllerMeResponse, AuthControllerPasswordData, AuthControllerPasswordResponse, AuthControllerUpdateProfileData, AuthControllerUpdateProfileResponse, AuthControllerVerifyData, AuthControllerVerifyResponse, BereichFreigabeControllerEigeneData, BereichFreigabeControllerEigeneResponse, BereichFreigabeControllerListData, BereichFreigabeControllerListResponse, BereichFreigabeControllerSetData, BereichFreigabeControllerSetResponse, ContentControllerCoachStylesData, ContentControllerCoachStylesResponse, ContentControllerPersonasData, ContentControllerPersonasResponse, ContentControllerRemoveCoachStyleData, ContentControllerRemoveCoachStyleResponse, ContentControllerRemovePersonaData, ContentControllerRemovePersonaResponse, ContentControllerUpsertCoachStyleData, ContentControllerUpsertCoachStyleResponse, ContentControllerUpsertPersonaData, ContentControllerUpsertPersonaResponse, EinheitFreigabeControllerEigeneData, EinheitFreigabeControllerEigeneResponse, EinheitFreigabeControllerListData, EinheitFreigabeControllerListResponse, EinheitFreigabeControllerSetData, EinheitFreigabeControllerSetResponse, HealthControllerCheckData, HealthControllerCheckResponse, HealthControllerPingData, HealthControllerPingResponse, IddControllerAbbrechenData, IddControllerAbbrechenResponse, IddControllerGetData, IddControllerGetResponse, IddControllerKapitelAendernData, IddControllerKapitelAendernResponse, IddControllerNachweisData, IddControllerNachweisListeData, IddControllerNachweisListeResponse, IddControllerNachweisResponse, IddControllerPruefungAbgebenData, IddControllerPruefungAbgebenResponse, IddControllerPruefungStartenData, IddControllerPruefungStartenResponse, IddControllerRunPruefenData, IddControllerRunPruefenResponse, IddControllerRunStandData, IddControllerRunStandResponse, IddControllerStartData, IddControllerStartResponse, IddControllerUebersichtData, IddControllerUebersichtResponse, LearningEssenceControllerGetData, LearningEssenceControllerGetResponse, LearningEssenceControllerRemoveData, LearningEssenceControllerRemoveResponse, LearningEssenceControllerSkipData, LearningEssenceControllerSkipResponse, LearningEssenceControllerStartData, LearningEssenceControllerStartResponse, PersonalPersonasControllerArchiveData, PersonalPersonasControllerArchiveResponse, PersonalPersonasControllerCreateData, PersonalPersonasControllerCreateResponse, PersonalPersonasControllerUpdateData, PersonalPersonasControllerUpdateResponse, ProcessRunControllerAdvanceData, ProcessRunControllerAdvanceResponse, ProcessRunControllerAvToolData, ProcessRunControllerAvToolResponse, ProcessRunControllerCreateData, ProcessRunControllerCreateResponse, ProcessRunControllerDebriefData, ProcessRunControllerDebriefResponse, ProcessRunControllerGetData, ProcessRunControllerGetResponse, ProcessRunControllerListData, ProcessRunControllerListResponse, ProcessRunControllerLoesungData, ProcessRunControllerLoesungResponse, ProcessRunControllerNachbereitungData, ProcessRunControllerNachbereitungResponse, ProcessRunControllerPreparationData, ProcessRunControllerPreparationResponse, ProcessRunControllerReportVoiceTurnsData, ProcessRunControllerReportVoiceTurnsResponse, PruefungControllerAntwortenData, PruefungControllerAntwortenResponse, PruefungControllerAuswertungenData, PruefungControllerAuswertungenResponse, PruefungControllerLernfelderData, PruefungControllerLernfelderResponse, PruefungControllerLernstandAbrufenData, PruefungControllerLernstandAbrufenResponse, PruefungControllerSetzeTerminData, PruefungControllerSetzeTerminResponse, PruefungControllerVerlaengereZielData, PruefungControllerVerlaengereZielResponse, PruefungControllerZuruecksetzenData, PruefungControllerZuruecksetzenResponse, ReflectionControllerAdvanceData, ReflectionControllerAdvanceResponse, ReflectionControllerGetData, ReflectionControllerGetResponse, ReflectionControllerRemoveData, ReflectionControllerRemoveResponse, SessionsControllerAppendMessagesData, SessionsControllerAppendMessagesResponse, SessionsControllerCompleteData, SessionsControllerCompleteResponse, SessionsControllerCreateData, SessionsControllerCreateResponse, SessionsControllerGenerateFeedbackData, SessionsControllerGenerateFeedbackResponse, SessionsControllerGetData, SessionsControllerGetResponse, SessionsControllerHeartbeatData, SessionsControllerHeartbeatResponse, SessionsControllerListData, SessionsControllerListResponse, SessionsControllerRateFeedbackData, SessionsControllerRateFeedbackResponse, SessionsControllerRemoveData, SessionsControllerRemoveResponse, SessionsControllerReportVoiceTurnsData, SessionsControllerReportVoiceTurnsResponse, TeamFreigabeControllerGetData, TeamFreigabeControllerGetResponse, TeamFreigabeControllerSetBereichData, TeamFreigabeControllerSetBereichResponse, TeamFreigabeControllerSetEinheitData, TeamFreigabeControllerSetEinheitResponse, TeamsControllerCreateData, TeamsControllerCreateResponse, TeamsControllerListData, TeamsControllerListResponse, TeamsControllerRemoveData, TeamsControllerRemoveResponse, TeamsControllerSetMembersData, TeamsControllerSetMembersResponse, TeamsControllerUpdateData, TeamsControllerUpdateResponse, TenantsControllerAuditLogData, TenantsControllerAuditLogPageData, TenantsControllerAuditLogPageResponse, TenantsControllerAuditLogResponse, TenantsControllerCreateData, TenantsControllerCreateResponse, TenantsControllerGetData, TenantsControllerGetResponse, TenantsControllerListData, TenantsControllerListResponse, TenantsControllerSetBausteineData, TenantsControllerSetBausteineResponse, TenantsControllerSetEmailDomainsData, TenantsControllerSetEmailDomainsResponse, TenantsControllerSubprozessorenData, TenantsControllerSubprozessorenResponse, TenantsControllerUpdateData, TenantsControllerUpdateResponse, TenantsControllerViewAsData, TenantsControllerViewAsResponse, UsersControllerEntsperrenData, UsersControllerEntsperrenResponse, UsersControllerIssueOneTimePasswordData, UsersControllerIssueOneTimePasswordResponse, UsersControllerListData, UsersControllerListResponse, UsersControllerRemoveData, UsersControllerRemoveResponse, UsersControllerSperrenData, UsersControllerSperrenResponse, UsersControllerUpsertData, UsersControllerUpsertResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const healthControllerCheckQueryKey = (options?: Options<HealthControllerCheckData>) => createQueryKey('healthControllerCheck', options);

/**
 * Erreichbarkeit und Datenbankverbindung
 *
 * Wird vom Container-Healthcheck genutzt.
 */
export const healthControllerCheckOptions = (options?: Options<HealthControllerCheckData>) => queryOptions<HealthControllerCheckResponse, DefaultError, HealthControllerCheckResponse, ReturnType<typeof healthControllerCheckQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthControllerCheck({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthControllerCheckQueryKey(options)
});

export const healthControllerPingQueryKey = (options?: Options<HealthControllerPingData>) => createQueryKey('healthControllerPing', options);

/**
 * Reine Erreichbarkeit, ohne Datenbank
 *
 * Für externes Monitoring (Uptime Kuma). Bewusst ohne Datenbankabfrage, damit der Monitor-Intervall keine Last erzeugt und ein Datenbankausfall vom Prozessausfall unterscheidbar bleibt (/api/health vs. /api/health/ping).
 */
export const healthControllerPingOptions = (options?: Options<HealthControllerPingData>) => queryOptions<HealthControllerPingResponse, DefaultError, HealthControllerPingResponse, ReturnType<typeof healthControllerPingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthControllerPing({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthControllerPingQueryKey(options)
});

/**
 * Anmeldelink anfordern
 *
 * Antwortet immer gleich, unabhängig davon, ob die Adresse existiert. Sonst würde die Anmeldemaske gültige Mailadressen preisgeben.
 */
export const authControllerMagicLinkMutation = (options?: Partial<Options<AuthControllerMagicLinkData>>): UseMutationOptions<AuthControllerMagicLinkResponse, DefaultError, Options<AuthControllerMagicLinkData>> => {
    const mutationOptions: UseMutationOptions<AuthControllerMagicLinkResponse, DefaultError, Options<AuthControllerMagicLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authControllerMagicLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Anmeldelink einlösen
 */
export const authControllerVerifyMutation = (options?: Partial<Options<AuthControllerVerifyData>>): UseMutationOptions<AuthControllerVerifyResponse, DefaultError, Options<AuthControllerVerifyData>> => {
    const mutationOptions: UseMutationOptions<AuthControllerVerifyResponse, DefaultError, Options<AuthControllerVerifyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authControllerVerify({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Anmeldung mit Einmal-Passwort
 *
 * Rückfallebene, wenn der Mailfilter einer Sparkasse den Anmeldelink verschluckt. Kein gleichwertiger zweiter Weg.
 */
export const authControllerPasswordMutation = (options?: Partial<Options<AuthControllerPasswordData>>): UseMutationOptions<AuthControllerPasswordResponse, DefaultError, Options<AuthControllerPasswordData>> => {
    const mutationOptions: UseMutationOptions<AuthControllerPasswordResponse, DefaultError, Options<AuthControllerPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authControllerPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authControllerMeQueryKey = (options?: Options<AuthControllerMeData>) => createQueryKey('authControllerMe', options);

/**
 * Angemeldeter Nutzer
 */
export const authControllerMeOptions = (options?: Options<AuthControllerMeData>) => queryOptions<AuthControllerMeResponse, DefaultError, AuthControllerMeResponse, ReturnType<typeof authControllerMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await authControllerMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authControllerMeQueryKey(options)
});

export const authControllerAbilityQueryKey = (options?: Options<AuthControllerAbilityData>) => createQueryKey('authControllerAbility', options);

/**
 * Berechtigungen des angemeldeten Nutzers
 *
 * Die CASL-Regeln, aus denen die Oberfläche ableitet, was sie anzeigt. Sie steuern nur die Darstellung; jede Anfrage wird serverseitig erneut geprüft. Berücksichtigt einen Wechsel in einen Mandanten.
 */
export const authControllerAbilityOptions = (options?: Options<AuthControllerAbilityData>) => queryOptions<AuthControllerAbilityResponse, DefaultError, AuthControllerAbilityResponse, ReturnType<typeof authControllerAbilityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await authControllerAbility({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authControllerAbilityQueryKey(options)
});

/**
 * Einwilligung bestätigen
 *
 * Beim ersten Login. Vorher wird kein Gespräch gespeichert, das der Nutzer nicht eingeordnet hat.
 */
export const authControllerConsentMutation = (options?: Partial<Options<AuthControllerConsentData>>): UseMutationOptions<AuthControllerConsentResponse, DefaultError, Options<AuthControllerConsentData>> => {
    const mutationOptions: UseMutationOptions<AuthControllerConsentResponse, DefaultError, Options<AuthControllerConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authControllerConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Ein Häppchen des Rundgangs abschließen
 *
 * Der Rundgang ist in drei Häppchen geteilt: Startseite, Gesprächstraining und Chat. Das genannte wurde durchlaufen oder übersprungen; beides zählt als beantwortet, danach startet es nicht mehr von allein.
 */
export const authControllerCompleteTourMutation = (options?: Partial<Options<AuthControllerCompleteTourData>>): UseMutationOptions<AuthControllerCompleteTourResponse, DefaultError, Options<AuthControllerCompleteTourData>> => {
    const mutationOptions: UseMutationOptions<AuthControllerCompleteTourResponse, DefaultError, Options<AuthControllerCompleteTourData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authControllerCompleteTour({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Name und Coach setzen
 *
 * Beim ersten Login über das Onboarding, später über die Einstellungen. Der Magic-Link-Login kennt nur die E-Mail, der Anzeigename kommt hier her.
 */
export const authControllerUpdateProfileMutation = (options?: Partial<Options<AuthControllerUpdateProfileData>>): UseMutationOptions<AuthControllerUpdateProfileResponse, DefaultError, Options<AuthControllerUpdateProfileData>> => {
    const mutationOptions: UseMutationOptions<AuthControllerUpdateProfileResponse, DefaultError, Options<AuthControllerUpdateProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authControllerUpdateProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Passwort ändern
 */
export const authControllerChangePasswordMutation = (options?: Partial<Options<AuthControllerChangePasswordData>>): UseMutationOptions<AuthControllerChangePasswordResponse, DefaultError, Options<AuthControllerChangePasswordData>> => {
    const mutationOptions: UseMutationOptions<AuthControllerChangePasswordResponse, DefaultError, Options<AuthControllerChangePasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authControllerChangePassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Abmelden
 */
export const authControllerLogoutMutation = (options?: Partial<Options<AuthControllerLogoutData>>): UseMutationOptions<AuthControllerLogoutResponse, DefaultError, Options<AuthControllerLogoutData>> => {
    const mutationOptions: UseMutationOptions<AuthControllerLogoutResponse, DefaultError, Options<AuthControllerLogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authControllerLogout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const usersControllerListQueryKey = (options?: Options<UsersControllerListData>) => createQueryKey('usersControllerList', options);

/**
 * Nutzer des eigenen Mandanten
 *
 * Nie der gesamte Bestand, immer auf den Mandanten gescoped. Die Plattformrolle kann mit `tenantId` gezielt eine Sparkasse abfragen, ohne die ganze Sitzung in sie zu wechseln.
 */
export const usersControllerListOptions = (options?: Options<UsersControllerListData>) => queryOptions<UsersControllerListResponse, DefaultError, UsersControllerListResponse, ReturnType<typeof usersControllerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await usersControllerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: usersControllerListQueryKey(options)
});

/**
 * Nutzer anlegen oder ändern
 *
 * Neue Nutzer starten im Status eingeladen. Die Plattformrolle kann den Mandanten im Feld `tenantId` mitgeben.
 */
export const usersControllerUpsertMutation = (options?: Partial<Options<UsersControllerUpsertData>>): UseMutationOptions<UsersControllerUpsertResponse, DefaultError, Options<UsersControllerUpsertData>> => {
    const mutationOptions: UseMutationOptions<UsersControllerUpsertResponse, DefaultError, Options<UsersControllerUpsertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersControllerUpsert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Einmal-Passwort vergeben
 *
 * Rückfallebene, wenn der Mailfilter den Anmeldelink verschluckt. Das Passwort wird genau einmal ausgeliefert, in der Datenbank steht nur der Hash. Beim ersten Login muss es gewechselt werden. Ein neuer Aufruf ersetzt das vorherige Passwort. Mit `variant: "email"` wird statt eines zufälligen Passworts der Mailname plus fester Zusatz vergeben (`a.becker-start-2026`), damit es sich einer ganzen Gruppe mit einer Ansage mitteilen lässt. Dieses Passwort ist bis zum Wechsel erratbar.
 */
export const usersControllerIssueOneTimePasswordMutation = (options?: Partial<Options<UsersControllerIssueOneTimePasswordData>>): UseMutationOptions<UsersControllerIssueOneTimePasswordResponse, DefaultError, Options<UsersControllerIssueOneTimePasswordData>> => {
    const mutationOptions: UseMutationOptions<UsersControllerIssueOneTimePasswordResponse, DefaultError, Options<UsersControllerIssueOneTimePasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersControllerIssueOneTimePassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Nutzer sperren
 *
 * Bestehende Sitzungen werden sofort entzogen. Daten bleiben erhalten.
 */
export const usersControllerSperrenMutation = (options?: Partial<Options<UsersControllerSperrenData>>): UseMutationOptions<UsersControllerSperrenResponse, DefaultError, Options<UsersControllerSperrenData>> => {
    const mutationOptions: UseMutationOptions<UsersControllerSperrenResponse, DefaultError, Options<UsersControllerSperrenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersControllerSperren({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sperre aufheben
 *
 * Ein Konto, das sich nie angemeldet hat, kehrt in den Status eingeladen zurück, damit die Einwilligung beim ersten Login bleibt.
 */
export const usersControllerEntsperrenMutation = (options?: Partial<Options<UsersControllerEntsperrenData>>): UseMutationOptions<UsersControllerEntsperrenResponse, DefaultError, Options<UsersControllerEntsperrenData>> => {
    const mutationOptions: UseMutationOptions<UsersControllerEntsperrenResponse, DefaultError, Options<UsersControllerEntsperrenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersControllerEntsperren({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Nutzer löschen
 *
 * Nur für gesperrte Konten. Löscht das Konto mit allen Trainingsdaten endgültig, darunter Gespräche, Feedback, Prüfungsstand und Lernessenz. Kostenzeilen bleiben ohne Personenbezug erhalten.
 */
export const usersControllerRemoveMutation = (options?: Partial<Options<UsersControllerRemoveData>>): UseMutationOptions<UsersControllerRemoveResponse, DefaultError, Options<UsersControllerRemoveData>> => {
    const mutationOptions: UseMutationOptions<UsersControllerRemoveResponse, DefaultError, Options<UsersControllerRemoveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await usersControllerRemove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const tenantsControllerListQueryKey = (options?: Options<TenantsControllerListData>) => createQueryKey('tenantsControllerList', options);

/**
 * Mandanten
 *
 * Nur die Plattformrolle sieht alle, sonst nur den eigenen.
 */
export const tenantsControllerListOptions = (options?: Options<TenantsControllerListData>) => queryOptions<TenantsControllerListResponse, DefaultError, TenantsControllerListResponse, ReturnType<typeof tenantsControllerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await tenantsControllerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: tenantsControllerListQueryKey(options)
});

/**
 * Mandanten anlegen
 *
 * Das Kürzel wird zur ID und ist danach nicht mehr änderbar. Neue Mandanten starten ohne Nutzer und ohne Sperren.
 */
export const tenantsControllerCreateMutation = (options?: Partial<Options<TenantsControllerCreateData>>): UseMutationOptions<TenantsControllerCreateResponse, DefaultError, Options<TenantsControllerCreateData>> => {
    const mutationOptions: UseMutationOptions<TenantsControllerCreateResponse, DefaultError, Options<TenantsControllerCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await tenantsControllerCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const tenantsControllerGetQueryKey = (options: Options<TenantsControllerGetData>) => createQueryKey('tenantsControllerGet', options);

/**
 * Ein Mandant
 */
export const tenantsControllerGetOptions = (options: Options<TenantsControllerGetData>) => queryOptions<TenantsControllerGetResponse, DefaultError, TenantsControllerGetResponse, ReturnType<typeof tenantsControllerGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await tenantsControllerGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: tenantsControllerGetQueryKey(options)
});

/**
 * Mandanten ändern
 *
 * Name, Region, Status und Plätze. Gelöscht wird nicht, solange die Aufbewahrungsfristen offen sind; stattdessen wird pausiert.
 */
export const tenantsControllerUpdateMutation = (options?: Partial<Options<TenantsControllerUpdateData>>): UseMutationOptions<TenantsControllerUpdateResponse, DefaultError, Options<TenantsControllerUpdateData>> => {
    const mutationOptions: UseMutationOptions<TenantsControllerUpdateResponse, DefaultError, Options<TenantsControllerUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await tenantsControllerUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * In einen Mandanten wechseln
 *
 * Hält im Protokoll fest, dass die Plattformrolle die Ansicht einer Sparkasse geöffnet hat. Der Wechsel selbst läuft über den Header `x-view-as-tenant`.
 */
export const tenantsControllerViewAsMutation = (options?: Partial<Options<TenantsControllerViewAsData>>): UseMutationOptions<TenantsControllerViewAsResponse, DefaultError, Options<TenantsControllerViewAsData>> => {
    const mutationOptions: UseMutationOptions<TenantsControllerViewAsResponse, DefaultError, Options<TenantsControllerViewAsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await tenantsControllerViewAs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * E-Mail-Domains für die Selbstanmeldung setzen
 *
 * Wer sich mit einer passenden Adresse einen Anmeldelink schicken lässt, bekommt beim Einlösen automatisch ein Beraterkonto in dieser Sparkasse. Muster: `sparkasse-beispiel.de` oder `*.sparkasse-beispiel.de`. Eine Domain kann nur einer Sparkasse gehören.
 */
export const tenantsControllerSetEmailDomainsMutation = (options?: Partial<Options<TenantsControllerSetEmailDomainsData>>): UseMutationOptions<TenantsControllerSetEmailDomainsResponse, DefaultError, Options<TenantsControllerSetEmailDomainsData>> => {
    const mutationOptions: UseMutationOptions<TenantsControllerSetEmailDomainsResponse, DefaultError, Options<TenantsControllerSetEmailDomainsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await tenantsControllerSetEmailDomains({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bausteine einer Sparkasse festlegen
 *
 * Legt fest, womit die Sparkasse trainiert, etwa ob das Einkommensgutachten den Einkommensschutz (BU) enthält. Gilt für jeden neuen Durchlauf der Sparkasse; die Berater:innen wählen das nicht selbst.
 */
export const tenantsControllerSetBausteineMutation = (options?: Partial<Options<TenantsControllerSetBausteineData>>): UseMutationOptions<TenantsControllerSetBausteineResponse, DefaultError, Options<TenantsControllerSetBausteineData>> => {
    const mutationOptions: UseMutationOptions<TenantsControllerSetBausteineResponse, DefaultError, Options<TenantsControllerSetBausteineData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await tenantsControllerSetBausteine({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const tenantsControllerAuditLogQueryKey = (options?: Options<TenantsControllerAuditLogData>) => createQueryKey('tenantsControllerAuditLog', options);

/**
 * Protokoll administrativer Vorgänge
 */
export const tenantsControllerAuditLogOptions = (options?: Options<TenantsControllerAuditLogData>) => queryOptions<TenantsControllerAuditLogResponse, DefaultError, TenantsControllerAuditLogResponse, ReturnType<typeof tenantsControllerAuditLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await tenantsControllerAuditLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: tenantsControllerAuditLogQueryKey(options)
});

export const tenantsControllerAuditLogPageQueryKey = (options?: Options<TenantsControllerAuditLogPageData>) => createQueryKey('tenantsControllerAuditLogPage', options);

/**
 * Technisches Protokoll der Verwaltung
 *
 * Alle Mandanten, neueste zuerst. Filter nach Mandant, Aktion (Teiltext) und Zeitraum (ISO-Datum). Seitenweise über `cursor`.
 */
export const tenantsControllerAuditLogPageOptions = (options?: Options<TenantsControllerAuditLogPageData>) => queryOptions<TenantsControllerAuditLogPageResponse, DefaultError, TenantsControllerAuditLogPageResponse, ReturnType<typeof tenantsControllerAuditLogPageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await tenantsControllerAuditLogPage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: tenantsControllerAuditLogPageQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const tenantsControllerAuditLogPageInfiniteQueryKey = (options?: Options<TenantsControllerAuditLogPageData>): QueryKey<Options<TenantsControllerAuditLogPageData>> => createQueryKey('tenantsControllerAuditLogPage', options, true);

/**
 * Technisches Protokoll der Verwaltung
 *
 * Alle Mandanten, neueste zuerst. Filter nach Mandant, Aktion (Teiltext) und Zeitraum (ISO-Datum). Seitenweise über `cursor`.
 */
export const tenantsControllerAuditLogPageInfiniteOptions = (options?: Options<TenantsControllerAuditLogPageData>) => {
    const opts = infiniteQueryOptions<TenantsControllerAuditLogPageResponse, DefaultError, InfiniteData<TenantsControllerAuditLogPageResponse>, QueryKey<Options<TenantsControllerAuditLogPageData>>, string | Pick<QueryKey<Options<TenantsControllerAuditLogPageData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<TenantsControllerAuditLogPageData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await tenantsControllerAuditLogPage({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: tenantsControllerAuditLogPageInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const tenantsControllerSubprozessorenQueryKey = (options?: Options<TenantsControllerSubprozessorenData>) => createQueryKey('tenantsControllerSubprozessoren', options);

/**
 * Subprozessoren
 *
 * Transparenzangabe gegenüber den Sparkassen. Bewusst ohne Anmeldung abrufbar, enthält keine personenbezogenen Daten.
 */
export const tenantsControllerSubprozessorenOptions = (options?: Options<TenantsControllerSubprozessorenData>) => queryOptions<TenantsControllerSubprozessorenResponse, DefaultError, TenantsControllerSubprozessorenResponse, ReturnType<typeof tenantsControllerSubprozessorenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await tenantsControllerSubprozessoren({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: tenantsControllerSubprozessorenQueryKey(options)
});

export const teamsControllerListQueryKey = (options?: Options<TeamsControllerListData>) => createQueryKey('teamsControllerList', options);

/**
 * Teams des eigenen Mandanten
 */
export const teamsControllerListOptions = (options?: Options<TeamsControllerListData>) => queryOptions<TeamsControllerListResponse, DefaultError, TeamsControllerListResponse, ReturnType<typeof teamsControllerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await teamsControllerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: teamsControllerListQueryKey(options)
});

/**
 * Pilotgruppe anlegen
 */
export const teamsControllerCreateMutation = (options?: Partial<Options<TeamsControllerCreateData>>): UseMutationOptions<TeamsControllerCreateResponse, DefaultError, Options<TeamsControllerCreateData>> => {
    const mutationOptions: UseMutationOptions<TeamsControllerCreateResponse, DefaultError, Options<TeamsControllerCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await teamsControllerCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Pilotgruppe löschen
 *
 * Die Mitglieder bleiben im Mandanten, nur ohne Gruppe. Ihre Trainings bleiben unverändert. Abweichende Freischaltungen der Gruppe entfallen.
 */
export const teamsControllerRemoveMutation = (options?: Partial<Options<TeamsControllerRemoveData>>): UseMutationOptions<TeamsControllerRemoveResponse, DefaultError, Options<TeamsControllerRemoveData>> => {
    const mutationOptions: UseMutationOptions<TeamsControllerRemoveResponse, DefaultError, Options<TeamsControllerRemoveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await teamsControllerRemove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Pilotgruppe ändern
 */
export const teamsControllerUpdateMutation = (options?: Partial<Options<TeamsControllerUpdateData>>): UseMutationOptions<TeamsControllerUpdateResponse, DefaultError, Options<TeamsControllerUpdateData>> => {
    const mutationOptions: UseMutationOptions<TeamsControllerUpdateResponse, DefaultError, Options<TeamsControllerUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await teamsControllerUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mitglieder einer Pilotgruppe hinzufügen oder entfernen
 *
 * Nur Konten desselben Mandanten. Wer bereits in einer anderen Gruppe ist, wechselt in diese. Jede Änderung wird protokolliert.
 */
export const teamsControllerSetMembersMutation = (options?: Partial<Options<TeamsControllerSetMembersData>>): UseMutationOptions<TeamsControllerSetMembersResponse, DefaultError, Options<TeamsControllerSetMembersData>> => {
    const mutationOptions: UseMutationOptions<TeamsControllerSetMembersResponse, DefaultError, Options<TeamsControllerSetMembersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await teamsControllerSetMembers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const auswertungControllerPruefungQueryKey = (options: Options<AuswertungControllerPruefungData>) => createQueryKey('auswertungControllerPruefung', options);

/**
 * Prüfungsvorbereitung je Mandant oder Pilotgruppe
 *
 * Ausschließlich Aggregate: Teilnehmende, Antworten und Quote richtig, gesamt und je Lernfeld. Unter fünf Personen werden keine Werte geliefert. Einzelergebnisse sind bewusst nicht abrufbar. Ein Coach sieht nur die eigene Pilotgruppe.
 */
export const auswertungControllerPruefungOptions = (options: Options<AuswertungControllerPruefungData>) => queryOptions<AuswertungControllerPruefungResponse, DefaultError, AuswertungControllerPruefungResponse, ReturnType<typeof auswertungControllerPruefungQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await auswertungControllerPruefung({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: auswertungControllerPruefungQueryKey(options)
});

export const auswertungControllerBearbeitungsstatusQueryKey = (options: Options<AuswertungControllerBearbeitungsstatusData>) => createQueryKey('auswertungControllerBearbeitungsstatus', options);

/**
 * Bearbeitungsstatus je Mandant oder Pilotgruppe
 *
 * Je Trainingseinheit, wie viele Personen begonnen und abgeschlossen haben. Keine Namen, unter fünf Personen keine Werte. Ein Coach sieht nur die eigene Pilotgruppe.
 */
export const auswertungControllerBearbeitungsstatusOptions = (options: Options<AuswertungControllerBearbeitungsstatusData>) => queryOptions<AuswertungControllerBearbeitungsstatusResponse, DefaultError, AuswertungControllerBearbeitungsstatusResponse, ReturnType<typeof auswertungControllerBearbeitungsstatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await auswertungControllerBearbeitungsstatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: auswertungControllerBearbeitungsstatusQueryKey(options)
});

export const auswertungControllerExportQueryKey = (options: Options<AuswertungControllerExportData>) => createQueryKey('auswertungControllerExport', options);

/**
 * Konsolidierte Ergebnisse eines Mandanten als CSV
 *
 * Dieselben Aggregate wie in der Verwaltung, für den Mandanten gesamt und je Pilotgruppe. Jeder Export wird protokolliert.
 */
export const auswertungControllerExportOptions = (options: Options<AuswertungControllerExportData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof auswertungControllerExportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await auswertungControllerExport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: auswertungControllerExportQueryKey(options)
});

export const einheitFreigabeControllerEigeneQueryKey = (options?: Options<EinheitFreigabeControllerEigeneData>) => createQueryKey('einheitFreigabeControllerEigene', options);

/**
 * Freischaltung der Trainingseinheiten in der eigenen Sparkasse
 *
 * Je Trainingseinheit, ob sie offen, gesperrt oder für einen Zeitpunkt geplant ist. Ein geplanter Termin gilt ab dem angegebenen Zeitpunkt ohne weiteres Zutun als offen.
 */
export const einheitFreigabeControllerEigeneOptions = (options?: Options<EinheitFreigabeControllerEigeneData>) => queryOptions<EinheitFreigabeControllerEigeneResponse, DefaultError, EinheitFreigabeControllerEigeneResponse, ReturnType<typeof einheitFreigabeControllerEigeneQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await einheitFreigabeControllerEigene({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: einheitFreigabeControllerEigeneQueryKey(options)
});

export const einheitFreigabeControllerListQueryKey = (options: Options<EinheitFreigabeControllerListData>) => createQueryKey('einheitFreigabeControllerList', options);

/**
 * Freischaltplan einer Sparkasse
 *
 * Die Führungskraft sieht nur den Plan der eigenen Sparkasse.
 */
export const einheitFreigabeControllerListOptions = (options: Options<EinheitFreigabeControllerListData>) => queryOptions<EinheitFreigabeControllerListResponse, DefaultError, EinheitFreigabeControllerListResponse, ReturnType<typeof einheitFreigabeControllerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await einheitFreigabeControllerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: einheitFreigabeControllerListQueryKey(options)
});

/**
 * Trainingseinheit freischalten, sperren oder planen
 *
 * `offen` schaltet sofort frei, `gesperrt` sperrt bis auf Weiteres, `geplant` sperrt bis zum angegebenen Zeitpunkt. Laufende Gesprächstrainings sind nicht betroffen. Jede Änderung wird protokolliert.
 */
export const einheitFreigabeControllerSetMutation = (options?: Partial<Options<EinheitFreigabeControllerSetData>>): UseMutationOptions<EinheitFreigabeControllerSetResponse, DefaultError, Options<EinheitFreigabeControllerSetData>> => {
    const mutationOptions: UseMutationOptions<EinheitFreigabeControllerSetResponse, DefaultError, Options<EinheitFreigabeControllerSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await einheitFreigabeControllerSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const bereichFreigabeControllerEigeneQueryKey = (options?: Options<BereichFreigabeControllerEigeneData>) => createQueryKey('bereichFreigabeControllerEigene', options);

/**
 * Freischaltung der Bereiche in der eigenen Sparkasse
 *
 * Je Bereich (Terminvorbereitung, Gesprächstraining, Produkttraining, Prüfungsvorbereitung), ob er offen, gesperrt oder für einen Zeitpunkt geplant ist.
 */
export const bereichFreigabeControllerEigeneOptions = (options?: Options<BereichFreigabeControllerEigeneData>) => queryOptions<BereichFreigabeControllerEigeneResponse, DefaultError, BereichFreigabeControllerEigeneResponse, ReturnType<typeof bereichFreigabeControllerEigeneQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await bereichFreigabeControllerEigene({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: bereichFreigabeControllerEigeneQueryKey(options)
});

export const bereichFreigabeControllerListQueryKey = (options: Options<BereichFreigabeControllerListData>) => createQueryKey('bereichFreigabeControllerList', options);

/**
 * Freischaltplan der Bereiche einer Sparkasse
 *
 * Die Führungskraft sieht nur den Plan der eigenen Sparkasse.
 */
export const bereichFreigabeControllerListOptions = (options: Options<BereichFreigabeControllerListData>) => queryOptions<BereichFreigabeControllerListResponse, DefaultError, BereichFreigabeControllerListResponse, ReturnType<typeof bereichFreigabeControllerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await bereichFreigabeControllerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: bereichFreigabeControllerListQueryKey(options)
});

/**
 * Bereich freischalten, sperren oder planen
 *
 * Gesperrt wird nur das Starten von Neuem. Laufende Gesprächstrainings, Auswertungen und bestehende Gespräche bleiben erreichbar. Jede Änderung wird protokolliert.
 */
export const bereichFreigabeControllerSetMutation = (options?: Partial<Options<BereichFreigabeControllerSetData>>): UseMutationOptions<BereichFreigabeControllerSetResponse, DefaultError, Options<BereichFreigabeControllerSetData>> => {
    const mutationOptions: UseMutationOptions<BereichFreigabeControllerSetResponse, DefaultError, Options<BereichFreigabeControllerSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bereichFreigabeControllerSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const teamFreigabeControllerGetQueryKey = (options: Options<TeamFreigabeControllerGetData>) => createQueryKey('teamFreigabeControllerGet', options);

/**
 * Freischaltung einer Pilotgruppe
 *
 * Je Bereich und Trainingseinheit der Stand, der für die Mitglieder gilt, daneben der Stand des Mandanten. `quelle` sagt, ob die Gruppe ihn überschreibt.
 */
export const teamFreigabeControllerGetOptions = (options: Options<TeamFreigabeControllerGetData>) => queryOptions<TeamFreigabeControllerGetResponse, DefaultError, TeamFreigabeControllerGetResponse, ReturnType<typeof teamFreigabeControllerGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await teamFreigabeControllerGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: teamFreigabeControllerGetQueryKey(options)
});

/**
 * Bereich für eine Pilotgruppe freischalten oder sperren
 *
 * `wie_mandant` hebt die Abweichung auf, die Gruppe folgt dann wieder dem Mandanten. `offen` schaltet auch frei, was der Mandant gesperrt hält. Jede Änderung wird protokolliert.
 */
export const teamFreigabeControllerSetBereichMutation = (options?: Partial<Options<TeamFreigabeControllerSetBereichData>>): UseMutationOptions<TeamFreigabeControllerSetBereichResponse, DefaultError, Options<TeamFreigabeControllerSetBereichData>> => {
    const mutationOptions: UseMutationOptions<TeamFreigabeControllerSetBereichResponse, DefaultError, Options<TeamFreigabeControllerSetBereichData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await teamFreigabeControllerSetBereich({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Trainingseinheit für eine Pilotgruppe freischalten oder sperren
 *
 * Wie bei den Bereichen. Einheiten ohne Inhalte bleiben für alle gesperrt.
 */
export const teamFreigabeControllerSetEinheitMutation = (options?: Partial<Options<TeamFreigabeControllerSetEinheitData>>): UseMutationOptions<TeamFreigabeControllerSetEinheitResponse, DefaultError, Options<TeamFreigabeControllerSetEinheitData>> => {
    const mutationOptions: UseMutationOptions<TeamFreigabeControllerSetEinheitResponse, DefaultError, Options<TeamFreigabeControllerSetEinheitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await teamFreigabeControllerSetEinheit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const contentControllerPersonasQueryKey = (options?: Options<ContentControllerPersonasData>) => createQueryKey('contentControllerPersonas', options);

/**
 * Personas
 *
 * Globale Vorlagen plus die eigenen des Mandanten. Fremde Mandanten sind nicht enthalten.
 */
export const contentControllerPersonasOptions = (options?: Options<ContentControllerPersonasData>) => queryOptions<ContentControllerPersonasResponse, DefaultError, ContentControllerPersonasResponse, ReturnType<typeof contentControllerPersonasQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contentControllerPersonas({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contentControllerPersonasQueryKey(options)
});

/**
 * Persona anlegen oder ändern
 *
 * Beim Bearbeiten einer globalen Vorlage entsteht automatisch eine mandantenspezifische Kopie, statt die Vorlage für alle zu verändern.
 */
export const contentControllerUpsertPersonaMutation = (options?: Partial<Options<ContentControllerUpsertPersonaData>>): UseMutationOptions<ContentControllerUpsertPersonaResponse, DefaultError, Options<ContentControllerUpsertPersonaData>> => {
    const mutationOptions: UseMutationOptions<ContentControllerUpsertPersonaResponse, DefaultError, Options<ContentControllerUpsertPersonaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentControllerUpsertPersona({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Persona archivieren
 *
 * Archiviert statt löscht, damit bestehende Gespräche ihre Referenz behalten.
 */
export const contentControllerRemovePersonaMutation = (options?: Partial<Options<ContentControllerRemovePersonaData>>): UseMutationOptions<ContentControllerRemovePersonaResponse, DefaultError, Options<ContentControllerRemovePersonaData>> => {
    const mutationOptions: UseMutationOptions<ContentControllerRemovePersonaResponse, DefaultError, Options<ContentControllerRemovePersonaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentControllerRemovePersona({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const contentControllerCoachStylesQueryKey = (options?: Options<ContentControllerCoachStylesData>) => createQueryKey('contentControllerCoachStyles', options);

/**
 * Coach-Stile
 */
export const contentControllerCoachStylesOptions = (options?: Options<ContentControllerCoachStylesData>) => queryOptions<ContentControllerCoachStylesResponse, DefaultError, ContentControllerCoachStylesResponse, ReturnType<typeof contentControllerCoachStylesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contentControllerCoachStyles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contentControllerCoachStylesQueryKey(options)
});

/**
 * Coach-Stil anlegen oder ändern
 */
export const contentControllerUpsertCoachStyleMutation = (options?: Partial<Options<ContentControllerUpsertCoachStyleData>>): UseMutationOptions<ContentControllerUpsertCoachStyleResponse, DefaultError, Options<ContentControllerUpsertCoachStyleData>> => {
    const mutationOptions: UseMutationOptions<ContentControllerUpsertCoachStyleResponse, DefaultError, Options<ContentControllerUpsertCoachStyleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentControllerUpsertCoachStyle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Coach-Stil deaktivieren
 */
export const contentControllerRemoveCoachStyleMutation = (options?: Partial<Options<ContentControllerRemoveCoachStyleData>>): UseMutationOptions<ContentControllerRemoveCoachStyleResponse, DefaultError, Options<ContentControllerRemoveCoachStyleData>> => {
    const mutationOptions: UseMutationOptions<ContentControllerRemoveCoachStyleResponse, DefaultError, Options<ContentControllerRemoveCoachStyleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await contentControllerRemoveCoachStyle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Privaten KI-Kunden erstellen
 */
export const personalPersonasControllerCreateMutation = (options?: Partial<Options<PersonalPersonasControllerCreateData>>): UseMutationOptions<PersonalPersonasControllerCreateResponse, DefaultError, Options<PersonalPersonasControllerCreateData>> => {
    const mutationOptions: UseMutationOptions<PersonalPersonasControllerCreateResponse, DefaultError, Options<PersonalPersonasControllerCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personalPersonasControllerCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Privaten KI-Kunden aus der Auswahl entfernen; Trainings bleiben erhalten
 */
export const personalPersonasControllerArchiveMutation = (options?: Partial<Options<PersonalPersonasControllerArchiveData>>): UseMutationOptions<PersonalPersonasControllerArchiveResponse, DefaultError, Options<PersonalPersonasControllerArchiveData>> => {
    const mutationOptions: UseMutationOptions<PersonalPersonasControllerArchiveResponse, DefaultError, Options<PersonalPersonasControllerArchiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personalPersonasControllerArchive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Privaten KI-Kunden als neue Version speichern
 */
export const personalPersonasControllerUpdateMutation = (options?: Partial<Options<PersonalPersonasControllerUpdateData>>): UseMutationOptions<PersonalPersonasControllerUpdateResponse, DefaultError, Options<PersonalPersonasControllerUpdateData>> => {
    const mutationOptions: UseMutationOptions<PersonalPersonasControllerUpdateResponse, DefaultError, Options<PersonalPersonasControllerUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await personalPersonasControllerUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sessionsControllerListQueryKey = (options?: Options<SessionsControllerListData>) => createQueryKey('sessionsControllerList', options);

/**
 * Eigene Trainingsgespräche
 *
 * Liefert ausschliesslich die Gespräche des angemeldeten Nutzers. Coaches und Führungskräfte sehen hier nichts von ihren Teams.
 */
export const sessionsControllerListOptions = (options?: Options<SessionsControllerListData>) => queryOptions<SessionsControllerListResponse, DefaultError, SessionsControllerListResponse, ReturnType<typeof sessionsControllerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await sessionsControllerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: sessionsControllerListQueryKey(options)
});

/**
 * Trainingsgespräch starten
 */
export const sessionsControllerCreateMutation = (options?: Partial<Options<SessionsControllerCreateData>>): UseMutationOptions<SessionsControllerCreateResponse, DefaultError, Options<SessionsControllerCreateData>> => {
    const mutationOptions: UseMutationOptions<SessionsControllerCreateResponse, DefaultError, Options<SessionsControllerCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sessionsControllerCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Eigenes Gespräch löschen
 *
 * Soft Delete. Hält die noch offene Entscheidung über Löschfristen offen, gibt dem Berater aber Kontrolle über die eigenen Gespräche.
 */
export const sessionsControllerRemoveMutation = (options?: Partial<Options<SessionsControllerRemoveData>>): UseMutationOptions<SessionsControllerRemoveResponse, DefaultError, Options<SessionsControllerRemoveData>> => {
    const mutationOptions: UseMutationOptions<SessionsControllerRemoveResponse, DefaultError, Options<SessionsControllerRemoveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sessionsControllerRemove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sessionsControllerGetQueryKey = (options: Options<SessionsControllerGetData>) => createQueryKey('sessionsControllerGet', options);

/**
 * Ein eigenes Trainingsgespräch
 */
export const sessionsControllerGetOptions = (options: Options<SessionsControllerGetData>) => queryOptions<SessionsControllerGetResponse, DefaultError, SessionsControllerGetResponse, ReturnType<typeof sessionsControllerGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await sessionsControllerGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: sessionsControllerGetQueryKey(options)
});

/**
 * Nachrichten anhängen
 */
export const sessionsControllerAppendMessagesMutation = (options?: Partial<Options<SessionsControllerAppendMessagesData>>): UseMutationOptions<SessionsControllerAppendMessagesResponse, DefaultError, Options<SessionsControllerAppendMessagesData>> => {
    const mutationOptions: UseMutationOptions<SessionsControllerAppendMessagesResponse, DefaultError, Options<SessionsControllerAppendMessagesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sessionsControllerAppendMessages({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sprachgespräch nachmelden
 *
 * Seit dem 12.08.2026 schreibt der Server die Beiträge eines Anrufs selbst, weil die Sprachverbindung über ihn läuft. Diese Route bleibt als Nachmeldeweg bestehen und ist bewusst idempotenzfrei: sie hängt an, was sie bekommt.
 */
export const sessionsControllerReportVoiceTurnsMutation = (options?: Partial<Options<SessionsControllerReportVoiceTurnsData>>): UseMutationOptions<SessionsControllerReportVoiceTurnsResponse, DefaultError, Options<SessionsControllerReportVoiceTurnsData>> => {
    const mutationOptions: UseMutationOptions<SessionsControllerReportVoiceTurnsResponse, DefaultError, Options<SessionsControllerReportVoiceTurnsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sessionsControllerReportVoiceTurns({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * IDD-Zeitstand melden
 *
 * Der Client zählt aktive Zeit, der Server verankert sie mit einem Zeitstempel. Gemeldete Zeit kann nie unter den erfassten Stand fallen.
 */
export const sessionsControllerHeartbeatMutation = (options?: Partial<Options<SessionsControllerHeartbeatData>>): UseMutationOptions<SessionsControllerHeartbeatResponse, DefaultError, Options<SessionsControllerHeartbeatData>> => {
    const mutationOptions: UseMutationOptions<SessionsControllerHeartbeatResponse, DefaultError, Options<SessionsControllerHeartbeatData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sessionsControllerHeartbeat({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Gespräch abschliessen
 */
export const sessionsControllerCompleteMutation = (options?: Partial<Options<SessionsControllerCompleteData>>): UseMutationOptions<SessionsControllerCompleteResponse, DefaultError, Options<SessionsControllerCompleteData>> => {
    const mutationOptions: UseMutationOptions<SessionsControllerCompleteResponse, DefaultError, Options<SessionsControllerCompleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sessionsControllerComplete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Feedback erzeugen
 *
 * Idempotent: liegt bereits ein Feedback vor, wird es zurückgegeben statt neu erzeugt. Sonst würde jede Anzeige erneut Kosten auslösen.
 */
export const sessionsControllerGenerateFeedbackMutation = (options?: Partial<Options<SessionsControllerGenerateFeedbackData>>): UseMutationOptions<SessionsControllerGenerateFeedbackResponse, DefaultError, Options<SessionsControllerGenerateFeedbackData>> => {
    const mutationOptions: UseMutationOptions<SessionsControllerGenerateFeedbackResponse, DefaultError, Options<SessionsControllerGenerateFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sessionsControllerGenerateFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * KI-Rückmeldung bewerten
 *
 * Zentrale Akzeptanzmessung des Proof of Concept. Wiederholtes Senden überschreibt die vorherige Bewertung.
 */
export const sessionsControllerRateFeedbackMutation = (options?: Partial<Options<SessionsControllerRateFeedbackData>>): UseMutationOptions<SessionsControllerRateFeedbackResponse, DefaultError, Options<SessionsControllerRateFeedbackData>> => {
    const mutationOptions: UseMutationOptions<SessionsControllerRateFeedbackResponse, DefaultError, Options<SessionsControllerRateFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sessionsControllerRateFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const aiControllerCoachThreadsQueryKey = (options?: Options<AiControllerCoachThreadsData>) => createQueryKey('aiControllerCoachThreads', options);

/**
 * Eigene Gespräche mit dem KI-Coach
 */
export const aiControllerCoachThreadsOptions = (options?: Options<AiControllerCoachThreadsData>) => queryOptions<AiControllerCoachThreadsResponse, DefaultError, AiControllerCoachThreadsResponse, ReturnType<typeof aiControllerCoachThreadsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await aiControllerCoachThreads({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: aiControllerCoachThreadsQueryKey(options)
});

/**
 * Neues Gespräch mit dem KI-Coach beginnen
 */
export const aiControllerCreateCoachThreadMutation = (options?: Partial<Options<AiControllerCreateCoachThreadData>>): UseMutationOptions<AiControllerCreateCoachThreadResponse, DefaultError, Options<AiControllerCreateCoachThreadData>> => {
    const mutationOptions: UseMutationOptions<AiControllerCreateCoachThreadResponse, DefaultError, Options<AiControllerCreateCoachThreadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await aiControllerCreateCoachThread({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Eigenes Gespräch mit dem KI-Coach löschen
 */
export const aiControllerDeleteCoachThreadMutation = (options?: Partial<Options<AiControllerDeleteCoachThreadData>>): UseMutationOptions<AiControllerDeleteCoachThreadResponse, DefaultError, Options<AiControllerDeleteCoachThreadData>> => {
    const mutationOptions: UseMutationOptions<AiControllerDeleteCoachThreadResponse, DefaultError, Options<AiControllerDeleteCoachThreadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await aiControllerDeleteCoachThread({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const aiControllerCoachThreadByIdQueryKey = (options: Options<AiControllerCoachThreadByIdData>) => createQueryKey('aiControllerCoachThreadById', options);

/**
 * Ein eigenes Gespräch mit dem KI-Coach
 */
export const aiControllerCoachThreadByIdOptions = (options: Options<AiControllerCoachThreadByIdData>) => queryOptions<AiControllerCoachThreadByIdResponse, DefaultError, AiControllerCoachThreadByIdResponse, ReturnType<typeof aiControllerCoachThreadByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await aiControllerCoachThreadById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: aiControllerCoachThreadByIdQueryKey(options)
});

/**
 * Eigenen Chatverlauf ändern (Titel, Favorit)
 */
export const aiControllerUpdateCoachThreadMutation = (options?: Partial<Options<AiControllerUpdateCoachThreadData>>): UseMutationOptions<AiControllerUpdateCoachThreadResponse, DefaultError, Options<AiControllerUpdateCoachThreadData>> => {
    const mutationOptions: UseMutationOptions<AiControllerUpdateCoachThreadResponse, DefaultError, Options<AiControllerUpdateCoachThreadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await aiControllerUpdateCoachThread({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sprachgespräch mit dem Coach nachmelden
 *
 * Seit dem 12.08.2026 schreibt der Server die Beiträge eines Anrufs selbst, weil die Sprachverbindung über ihn läuft. Diese Route bleibt als Nachmeldeweg bestehen.
 */
export const aiControllerReportThreadVoiceTurnsMutation = (options?: Partial<Options<AiControllerReportThreadVoiceTurnsData>>): UseMutationOptions<AiControllerReportThreadVoiceTurnsResponse, DefaultError, Options<AiControllerReportThreadVoiceTurnsData>> => {
    const mutationOptions: UseMutationOptions<AiControllerReportThreadVoiceTurnsResponse, DefaultError, Options<AiControllerReportThreadVoiceTurnsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await aiControllerReportThreadVoiceTurns({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Audioaufnahme transkribieren
 */
export const aiControllerTranscribeMutation = (options?: Partial<Options<AiControllerTranscribeData>>): UseMutationOptions<AiControllerTranscribeResponse, DefaultError, Options<AiControllerTranscribeData>> => {
    const mutationOptions: UseMutationOptions<AiControllerTranscribeResponse, DefaultError, Options<AiControllerTranscribeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await aiControllerTranscribe({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const reflectionControllerGetQueryKey = (options: Options<ReflectionControllerGetData>) => createQueryKey('reflectionControllerGet', options);

/**
 * Reflexionsgespräch zu einer Phase
 *
 * Stufe, Verlauf und die bisher eingebrachte Selbsteinschätzung. Wird beim ersten Aufruf angelegt.
 */
export const reflectionControllerGetOptions = (options: Options<ReflectionControllerGetData>) => queryOptions<ReflectionControllerGetResponse, DefaultError, ReflectionControllerGetResponse, ReturnType<typeof reflectionControllerGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await reflectionControllerGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: reflectionControllerGetQueryKey(options)
});

/**
 * Stufe des Reflexionsgesprächs weiterschalten
 *
 * Läuft nie zurück. Die gemeinsame Analyse setzt eine eingebrachte Selbsteinschätzung voraus, es sei denn, die Beraterin fordert sie ausdrücklich an.
 */
export const reflectionControllerAdvanceMutation = (options?: Partial<Options<ReflectionControllerAdvanceData>>): UseMutationOptions<ReflectionControllerAdvanceResponse, DefaultError, Options<ReflectionControllerAdvanceData>> => {
    const mutationOptions: UseMutationOptions<ReflectionControllerAdvanceResponse, DefaultError, Options<ReflectionControllerAdvanceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reflectionControllerAdvance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Selbsteinschätzung löschen
 *
 * Entfernt die eigene Einschätzung und behält das Feedback. Die Hoheit über die Coaching-Ergebnisse liegt beim Mitarbeiter.
 */
export const reflectionControllerRemoveMutation = (options?: Partial<Options<ReflectionControllerRemoveData>>): UseMutationOptions<ReflectionControllerRemoveResponse, DefaultError, Options<ReflectionControllerRemoveData>> => {
    const mutationOptions: UseMutationOptions<ReflectionControllerRemoveResponse, DefaultError, Options<ReflectionControllerRemoveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reflectionControllerRemove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Lernentwicklungs-Essenz löschen
 *
 * Entfernt Essenz und erfasste Antworten. Das Kennenlerngespräch bleibt und ist separat löschbar — die Hoheit über beide liegt beim Mitarbeiter.
 */
export const learningEssenceControllerRemoveMutation = (options?: Partial<Options<LearningEssenceControllerRemoveData>>): UseMutationOptions<LearningEssenceControllerRemoveResponse, DefaultError, Options<LearningEssenceControllerRemoveData>> => {
    const mutationOptions: UseMutationOptions<LearningEssenceControllerRemoveResponse, DefaultError, Options<LearningEssenceControllerRemoveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await learningEssenceControllerRemove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const learningEssenceControllerGetQueryKey = (options?: Options<LearningEssenceControllerGetData>) => createQueryKey('learningEssenceControllerGet', options);

/**
 * Eigene Lernentwicklungs-Essenz
 *
 * Status des Kennenlerngesprächs und, nach Abschluss, die daraus abgeleiteten Prioritäten, Stärken und Handlungsfelder. Immer die eigene: es gibt keinen Zugriff auf die Essenz anderer Nutzer.
 */
export const learningEssenceControllerGetOptions = (options?: Options<LearningEssenceControllerGetData>) => queryOptions<LearningEssenceControllerGetResponse, DefaultError, LearningEssenceControllerGetResponse, ReturnType<typeof learningEssenceControllerGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await learningEssenceControllerGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: learningEssenceControllerGetQueryKey(options)
});

/**
 * Kennenlerngespräch beginnen oder fortsetzen
 *
 * Legt beim ersten Aufruf das Gespräch mit dem gewählten Coach an, inklusive seiner Eröffnung. Weitere Aufrufe liefern dasselbe Gespräch.
 */
export const learningEssenceControllerStartMutation = (options?: Partial<Options<LearningEssenceControllerStartData>>): UseMutationOptions<LearningEssenceControllerStartResponse, DefaultError, Options<LearningEssenceControllerStartData>> => {
    const mutationOptions: UseMutationOptions<LearningEssenceControllerStartResponse, DefaultError, Options<LearningEssenceControllerStartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await learningEssenceControllerStart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Kennenlernen überspringen
 *
 * Merkt das Überspringen; die Startseite erinnert weiter daran. Nach einem Abschluss nicht mehr möglich.
 */
export const learningEssenceControllerSkipMutation = (options?: Partial<Options<LearningEssenceControllerSkipData>>): UseMutationOptions<LearningEssenceControllerSkipResponse, DefaultError, Options<LearningEssenceControllerSkipData>> => {
    const mutationOptions: UseMutationOptions<LearningEssenceControllerSkipResponse, DefaultError, Options<LearningEssenceControllerSkipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await learningEssenceControllerSkip({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const pruefungControllerLernfelderQueryKey = (options?: Options<PruefungControllerLernfelderData>) => createQueryKey('pruefungControllerLernfelder', options);

/**
 * Lernfelder des aktiven Fragenkatalogs
 *
 * Die Lernfelder samt eigenem Fortschritt. Ist noch kein Katalog eingespielt, kommt eine leere Liste ohne Katalogangabe zurück — die Oberfläche zeigt dann einen Hinweis statt einer leeren Seite.
 */
export const pruefungControllerLernfelderOptions = (options?: Options<PruefungControllerLernfelderData>) => queryOptions<PruefungControllerLernfelderResponse, DefaultError, PruefungControllerLernfelderResponse, ReturnType<typeof pruefungControllerLernfelderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await pruefungControllerLernfelder({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: pruefungControllerLernfelderQueryKey(options)
});

/**
 * Eigenen Lernstand zurücksetzen
 *
 * Löscht Antworten, Wiedervorlage und Merkzettel. Der Fragenkatalog bleibt unberührt.
 */
export const pruefungControllerZuruecksetzenMutation = (options?: Partial<Options<PruefungControllerZuruecksetzenData>>): UseMutationOptions<PruefungControllerZuruecksetzenResponse, DefaultError, Options<PruefungControllerZuruecksetzenData>> => {
    const mutationOptions: UseMutationOptions<PruefungControllerZuruecksetzenResponse, DefaultError, Options<PruefungControllerZuruecksetzenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pruefungControllerZuruecksetzen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const pruefungControllerLernstandAbrufenQueryKey = (options?: Options<PruefungControllerLernstandAbrufenData>) => createQueryKey('pruefungControllerLernstandAbrufen', options);

/**
 * Eigener Lernstand
 *
 * Quoten je Lernfeld und die Beobachtungen des Coaches. Immer der eigene: es gibt keinen Zugriff auf den Lernstand anderer Nutzer.
 */
export const pruefungControllerLernstandAbrufenOptions = (options?: Options<PruefungControllerLernstandAbrufenData>) => queryOptions<PruefungControllerLernstandAbrufenResponse, DefaultError, PruefungControllerLernstandAbrufenResponse, ReturnType<typeof pruefungControllerLernstandAbrufenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await pruefungControllerLernstandAbrufen({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: pruefungControllerLernstandAbrufenQueryKey(options)
});

/**
 * Prüfungstermin setzen oder löschen
 *
 * Der Coach nutzt den Termin, um das Lerntempo einzuordnen.
 */
export const pruefungControllerSetzeTerminMutation = (options?: Partial<Options<PruefungControllerSetzeTerminData>>): UseMutationOptions<PruefungControllerSetzeTerminResponse, DefaultError, Options<PruefungControllerSetzeTerminData>> => {
    const mutationOptions: UseMutationOptions<PruefungControllerSetzeTerminResponse, DefaultError, Options<PruefungControllerSetzeTerminData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pruefungControllerSetzeTermin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Antwort auf eine Prüfungsfrage abgeben
 *
 * Bewertet die Antwort gegen den Katalog und schreibt den Lernstand fort. Bei den Auswahltypen ist die Bewertung rein rechnerisch; nur bei offenen Fragen urteilt ein Modell gegen die hinterlegte Musterantwort. Die Antwort enthält die richtige Lösung und die Begründung aus dem Katalog — beides erst jetzt, nicht schon beim Stellen der Frage.
 */
export const pruefungControllerAntwortenMutation = (options?: Partial<Options<PruefungControllerAntwortenData>>): UseMutationOptions<PruefungControllerAntwortenResponse, DefaultError, Options<PruefungControllerAntwortenData>> => {
    const mutationOptions: UseMutationOptions<PruefungControllerAntwortenResponse, DefaultError, Options<PruefungControllerAntwortenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pruefungControllerAntworten({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const pruefungControllerAuswertungenQueryKey = (options: Options<PruefungControllerAuswertungenData>) => createQueryKey('pruefungControllerAuswertungen', options);

/**
 * Auswertungen eines Gesprächs
 *
 * Damit beantwortete Fragen nach dem Neuladen im Ergebniszustand stehen statt wieder offen. Nur für eigene Gespräche.
 */
export const pruefungControllerAuswertungenOptions = (options: Options<PruefungControllerAuswertungenData>) => queryOptions<PruefungControllerAuswertungenResponse, DefaultError, PruefungControllerAuswertungenResponse, ReturnType<typeof pruefungControllerAuswertungenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await pruefungControllerAuswertungen({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: pruefungControllerAuswertungenQueryKey(options)
});

/**
 * Lernziel eines Gesprächs verlängern
 *
 * Erhöht die Zahl der Fragen, die die Beraterin in diesem Gespräch beantworten will, gerechnet ab dem bisherigen Ziel. Nur für eigene Prüfungsgespräche.
 */
export const pruefungControllerVerlaengereZielMutation = (options?: Partial<Options<PruefungControllerVerlaengereZielData>>): UseMutationOptions<PruefungControllerVerlaengereZielResponse, DefaultError, Options<PruefungControllerVerlaengereZielData>> => {
    const mutationOptions: UseMutationOptions<PruefungControllerVerlaengereZielResponse, DefaultError, Options<PruefungControllerVerlaengereZielData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await pruefungControllerVerlaengereZiel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const iddControllerRunStandQueryKey = (options: Options<IddControllerRunStandData>) => createQueryKey('iddControllerRunStand', options);

/**
 * IDD-Stand eines Durchlaufs
 *
 * Pflichtschritte und Auftrag, wenn der Durchlauf ein IDD-Szenario ist. Leer für jeden anderen Durchlauf, auch für fremde.
 */
export const iddControllerRunStandOptions = (options: Options<IddControllerRunStandData>) => queryOptions<IddControllerRunStandResponse, DefaultError, IddControllerRunStandResponse, ReturnType<typeof iddControllerRunStandQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await iddControllerRunStand({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: iddControllerRunStandQueryKey(options)
});

/**
 * Pflichtschritte am bisherigen Gespräch prüfen
 *
 * Prüft nur Beiträge, die seit der letzten Prüfung dazugekommen sind. Ein erreichter Pflichtschritt wird nie zurückgenommen.
 */
export const iddControllerRunPruefenMutation = (options?: Partial<Options<IddControllerRunPruefenData>>): UseMutationOptions<IddControllerRunPruefenResponse, DefaultError, Options<IddControllerRunPruefenData>> => {
    const mutationOptions: UseMutationOptions<IddControllerRunPruefenResponse, DefaultError, Options<IddControllerRunPruefenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await iddControllerRunPruefen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const iddControllerUebersichtQueryKey = (options?: Options<IddControllerUebersichtData>) => createQueryKey('iddControllerUebersicht', options);

/**
 * IDD-Bereich: Module, Stand im Kalenderjahr und Historie
 *
 * Je Modul, ob es im laufenden Kalenderjahr bereits angerechnet wurde und ob ein Training läuft, dazu die angerechneten Minuten und alle eigenen Nachweise.
 */
export const iddControllerUebersichtOptions = (options?: Options<IddControllerUebersichtData>) => queryOptions<IddControllerUebersichtResponse, DefaultError, IddControllerUebersichtResponse, ReturnType<typeof iddControllerUebersichtQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await iddControllerUebersicht({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: iddControllerUebersichtQueryKey(options)
});

/**
 * IDD-Training starten
 *
 * Startet ein Gesprächsszenario als Durchlauf oder ein Produkttraining mit den gewählten Lernbausteinen. Ist das Modul im Kalenderjahr bereits angerechnet, läuft das Training als Wiederholung ohne Anrechnung.
 */
export const iddControllerStartMutation = (options?: Partial<Options<IddControllerStartData>>): UseMutationOptions<IddControllerStartResponse, DefaultError, Options<IddControllerStartData>> => {
    const mutationOptions: UseMutationOptions<IddControllerStartResponse, DefaultError, Options<IddControllerStartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await iddControllerStart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const iddControllerGetQueryKey = (options: Options<IddControllerGetData>) => createQueryKey('iddControllerGet', options);

/**
 * Ein eigenes IDD-Training
 */
export const iddControllerGetOptions = (options: Options<IddControllerGetData>) => queryOptions<IddControllerGetResponse, DefaultError, IddControllerGetResponse, ReturnType<typeof iddControllerGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await iddControllerGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: iddControllerGetQueryKey(options)
});

/**
 * IDD-Training abbrechen, ohne Anrechnung
 */
export const iddControllerAbbrechenMutation = (options?: Partial<Options<IddControllerAbbrechenData>>): UseMutationOptions<IddControllerAbbrechenResponse, DefaultError, Options<IddControllerAbbrechenData>> => {
    const mutationOptions: UseMutationOptions<IddControllerAbbrechenResponse, DefaultError, Options<IddControllerAbbrechenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await iddControllerAbbrechen({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Lernbausteine eines laufenden Produkttrainings ändern
 *
 * Bearbeitete Bausteine bleiben gewählt. Die anrechenbare Lernzeit richtet sich danach neu nach der Auswahl.
 */
export const iddControllerKapitelAendernMutation = (options?: Partial<Options<IddControllerKapitelAendernData>>): UseMutationOptions<IddControllerKapitelAendernResponse, DefaultError, Options<IddControllerKapitelAendernData>> => {
    const mutationOptions: UseMutationOptions<IddControllerKapitelAendernResponse, DefaultError, Options<IddControllerKapitelAendernData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await iddControllerKapitelAendern({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Lernerfolgskontrolle starten
 *
 * Zieht Fragen ausschließlich aus den bearbeiteten Kapiteln. Ist ein Versuch offen, bleibt er bestehen.
 */
export const iddControllerPruefungStartenMutation = (options?: Partial<Options<IddControllerPruefungStartenData>>): UseMutationOptions<IddControllerPruefungStartenResponse, DefaultError, Options<IddControllerPruefungStartenData>> => {
    const mutationOptions: UseMutationOptions<IddControllerPruefungStartenResponse, DefaultError, Options<IddControllerPruefungStartenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await iddControllerPruefungStarten({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Lernerfolgskontrolle abgeben
 *
 * Bewertet rechnerisch gegen den Fragenkatalog. Ab 70 Prozent ist sie bestanden und der Nachweis wird erzeugt; sonst kann sie wiederholt werden.
 */
export const iddControllerPruefungAbgebenMutation = (options?: Partial<Options<IddControllerPruefungAbgebenData>>): UseMutationOptions<IddControllerPruefungAbgebenResponse, DefaultError, Options<IddControllerPruefungAbgebenData>> => {
    const mutationOptions: UseMutationOptions<IddControllerPruefungAbgebenResponse, DefaultError, Options<IddControllerPruefungAbgebenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await iddControllerPruefungAbgeben({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const iddControllerNachweisListeQueryKey = (options?: Options<IddControllerNachweisListeData>) => createQueryKey('iddControllerNachweisListe', options);

/**
 * Eigene IDD-Nachweise, auch aus Vorjahren
 */
export const iddControllerNachweisListeOptions = (options?: Options<IddControllerNachweisListeData>) => queryOptions<IddControllerNachweisListeResponse, DefaultError, IddControllerNachweisListeResponse, ReturnType<typeof iddControllerNachweisListeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await iddControllerNachweisListe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: iddControllerNachweisListeQueryKey(options)
});

export const iddControllerNachweisQueryKey = (options: Options<IddControllerNachweisData>) => createQueryKey('iddControllerNachweis', options);

/**
 * Ein eigener IDD-Nachweis
 */
export const iddControllerNachweisOptions = (options: Options<IddControllerNachweisData>) => queryOptions<IddControllerNachweisResponse, DefaultError, IddControllerNachweisResponse, ReturnType<typeof iddControllerNachweisQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await iddControllerNachweis({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: iddControllerNachweisQueryKey(options)
});

export const processRunControllerListQueryKey = (options?: Options<ProcessRunControllerListData>) => createQueryKey('processRunControllerList', options);

/**
 * Eigene Gesprächstrainings (kompakte Listenform)
 */
export const processRunControllerListOptions = (options?: Options<ProcessRunControllerListData>) => queryOptions<ProcessRunControllerListResponse, DefaultError, ProcessRunControllerListResponse, ReturnType<typeof processRunControllerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await processRunControllerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: processRunControllerListQueryKey(options)
});

/**
 * Gesprächstraining starten
 */
export const processRunControllerCreateMutation = (options?: Partial<Options<ProcessRunControllerCreateData>>): UseMutationOptions<ProcessRunControllerCreateResponse, DefaultError, Options<ProcessRunControllerCreateData>> => {
    const mutationOptions: UseMutationOptions<ProcessRunControllerCreateResponse, DefaultError, Options<ProcessRunControllerCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await processRunControllerCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const processRunControllerGetQueryKey = (options: Options<ProcessRunControllerGetData>) => createQueryKey('processRunControllerGet', options);

/**
 * Ein eigenes Gesprächstraining
 */
export const processRunControllerGetOptions = (options: Options<ProcessRunControllerGetData>) => queryOptions<ProcessRunControllerGetResponse, DefaultError, ProcessRunControllerGetResponse, ReturnType<typeof processRunControllerGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await processRunControllerGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: processRunControllerGetQueryKey(options)
});

/**
 * Aktuelle Phase abschließen und zur nächsten wechseln
 */
export const processRunControllerAdvanceMutation = (options?: Partial<Options<ProcessRunControllerAdvanceData>>): UseMutationOptions<ProcessRunControllerAdvanceResponse, DefaultError, Options<ProcessRunControllerAdvanceData>> => {
    const mutationOptions: UseMutationOptions<ProcessRunControllerAdvanceResponse, DefaultError, Options<ProcessRunControllerAdvanceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await processRunControllerAdvance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Gesprächsvorbereitung abschließen
 */
export const processRunControllerPreparationMutation = (options?: Partial<Options<ProcessRunControllerPreparationData>>): UseMutationOptions<ProcessRunControllerPreparationResponse, DefaultError, Options<ProcessRunControllerPreparationData>> => {
    const mutationOptions: UseMutationOptions<ProcessRunControllerPreparationResponse, DefaultError, Options<ProcessRunControllerPreparationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await processRunControllerPreparation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Nacharbeit abschließen und das Gesamtbild freigeben
 *
 * Schließt das Sparring der Nachbereitung ab und hält die Antworten auf die Leitfragen fest. Der Durchlauf bleibt in dieser Einheit — beendet wird er über /advance, wenn der Bericht gelesen ist.
 */
export const processRunControllerNachbereitungMutation = (options?: Partial<Options<ProcessRunControllerNachbereitungData>>): UseMutationOptions<ProcessRunControllerNachbereitungResponse, DefaultError, Options<ProcessRunControllerNachbereitungData>> => {
    const mutationOptions: UseMutationOptions<ProcessRunControllerNachbereitungResponse, DefaultError, Options<ProcessRunControllerNachbereitungData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await processRunControllerNachbereitung({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stand des AV-Tools festhalten
 *
 * Speichert die Eingaben des Beratungswerkzeugs im Fallzustand und rechnet das Ergebnis serverseitig neu. Mit `zeigen` wird die Versorgungslücke zusätzlich in den Fallzustand übernommen — erst dadurch kennt der KI-Kunde die Zahl. Der Durchlauf bleibt in der Einheit; abgeschlossen wird sie wie bisher über /advance.
 */
export const processRunControllerAvToolMutation = (options?: Partial<Options<ProcessRunControllerAvToolData>>): UseMutationOptions<ProcessRunControllerAvToolResponse, DefaultError, Options<ProcessRunControllerAvToolData>> => {
    const mutationOptions: UseMutationOptions<ProcessRunControllerAvToolResponse, DefaultError, Options<ProcessRunControllerAvToolData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await processRunControllerAvTool({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Lösungsvorschlag festhalten
 *
 * Speichert die Produktauswahl aus „Lösung & Abschluss“ im Fallzustand. Mit `zeigen` dreht die Beraterin den Bildschirm zum Kunden: der Server baut daraus die Handlungszeile, auf die der KI-Kunde reagiert, auch im laufenden Sprachgespräch. Nur in dieser Einheit erlaubt.
 */
export const processRunControllerLoesungMutation = (options?: Partial<Options<ProcessRunControllerLoesungData>>): UseMutationOptions<ProcessRunControllerLoesungResponse, DefaultError, Options<ProcessRunControllerLoesungData>> => {
    const mutationOptions: UseMutationOptions<ProcessRunControllerLoesungResponse, DefaultError, Options<ProcessRunControllerLoesungData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await processRunControllerLoesung({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const processRunControllerDebriefQueryKey = (options: Options<ProcessRunControllerDebriefData>) => createQueryKey('processRunControllerDebrief', options);

/**
 * Gesamt-Debrief über alle IVFP-Phasen
 */
export const processRunControllerDebriefOptions = (options: Options<ProcessRunControllerDebriefData>) => queryOptions<ProcessRunControllerDebriefResponse, DefaultError, ProcessRunControllerDebriefResponse, ReturnType<typeof processRunControllerDebriefQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await processRunControllerDebrief({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: processRunControllerDebriefQueryKey(options)
});

/**
 * Sprachgespräch mit dem Durchlauf-Coach nachmelden
 *
 * Ohne diese Meldung existiert der Anruf weder im Coach-Verlauf des Durchlaufs noch in der Kostenrechnung.
 */
export const processRunControllerReportVoiceTurnsMutation = (options?: Partial<Options<ProcessRunControllerReportVoiceTurnsData>>): UseMutationOptions<ProcessRunControllerReportVoiceTurnsResponse, DefaultError, Options<ProcessRunControllerReportVoiceTurnsData>> => {
    const mutationOptions: UseMutationOptions<ProcessRunControllerReportVoiceTurnsResponse, DefaultError, Options<ProcessRunControllerReportVoiceTurnsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await processRunControllerReportVoiceTurns({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const analyticsControllerOverviewQueryKey = (options?: Options<AnalyticsControllerOverviewData>) => createQueryKey('analyticsControllerOverview', options);

/**
 * Kennzahlen des Mandanten
 *
 * Ausschliesslich Aggregate: Nutzung, IDD-Zeit, Akzeptanz und Kosten. Einzelne Gespräche sind hier bewusst nicht enthalten.
 */
export const analyticsControllerOverviewOptions = (options?: Options<AnalyticsControllerOverviewData>) => queryOptions<AnalyticsControllerOverviewResponse, DefaultError, AnalyticsControllerOverviewResponse, ReturnType<typeof analyticsControllerOverviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await analyticsControllerOverview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: analyticsControllerOverviewQueryKey(options)
});

export const analyticsControllerTrainingsPerDayQueryKey = (options?: Options<AnalyticsControllerTrainingsPerDayData>) => createQueryKey('analyticsControllerTrainingsPerDay', options);

/**
 * Trainings je Tag
 */
export const analyticsControllerTrainingsPerDayOptions = (options?: Options<AnalyticsControllerTrainingsPerDayData>) => queryOptions<AnalyticsControllerTrainingsPerDayResponse, DefaultError, AnalyticsControllerTrainingsPerDayResponse, ReturnType<typeof analyticsControllerTrainingsPerDayQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await analyticsControllerTrainingsPerDay({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: analyticsControllerTrainingsPerDayQueryKey(options)
});

export const analyticsControllerDimensionsQueryKey = (options?: Options<AnalyticsControllerDimensionsData>) => createQueryKey('analyticsControllerDimensions', options);

/**
 * Durchschnitt je Feedback-Dimension
 */
export const analyticsControllerDimensionsOptions = (options?: Options<AnalyticsControllerDimensionsData>) => queryOptions<AnalyticsControllerDimensionsResponse, DefaultError, AnalyticsControllerDimensionsResponse, ReturnType<typeof analyticsControllerDimensionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await analyticsControllerDimensions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: analyticsControllerDimensionsQueryKey(options)
});
